// extracted by mini-css-extract-plugin
export default {"button":"kw3Noh4Gb1kTCG6Y3iIE"};